import React from 'react';
import {connect} from 'react-redux';
import {connectI18n} from '../../connects';
import {compose} from 'redux';
import WaitWhileBusy from '../../WaitWhileBusy';
import Screen from '../Screen';
import TopBar from '../../elements/TopBar/TopBar';
import Scrollable from '../../elements/Scrollable';
import ScrollableList from '../../elements/ScrollableList';
import ListItem from '../../elements/DEPRECATED_ListItem';
import VerticalCenter from '../../elements/VerticalCenter';
import Link from '../../elements/Link';

class GlobalContacts extends React.Component {
    render() {
        let {i18n, connections} = this.props,
            header = (
                <div>
                    <TopBar returnURL="..">{i18n['label.my.contacts']}</TopBar>
                    <hr />
                </div>
            ),
            textStyle = {};

        return (
            <Screen header={header}>
                {connections.length ? (
                    <ScrollableList className="" savePosition="global-contacts">
                        {connections.map(connection => (
                            <Link key={connection.id} href={'./' + connection.id}>
                                <ListItem tagName="div" icon={connection.image_url} next>
                                    <div className="username text name" style={textStyle}>
                                        {connection.first_name}&nbsp;{connection.last_name}
                                    </div>
                                    <div className="position" style={textStyle}>
                                        {connection.position}
                                    </div>
                                    <div className="company" style={textStyle}>
                                        {connection.company}
                                    </div>
                                </ListItem>
                                <hr className="thin" />
                            </Link>
                        ))}
                    </ScrollableList>
                ) : (
                    <Scrollable>
                        <VerticalCenter>
                            <div className="content">
                                <p className="text-center">{i18n['contacts.empty']}</p>
                            </div>
                        </VerticalCenter>
                    </Scrollable>
                )}
            </Screen>
        );
    }
}

const ConnectedScreen = compose(
    connectI18n,
    connect((state, props) => ({
        connections: state.connections.listed,
    }))
)(GlobalContacts);

export default props => (
    <WaitWhileBusy>
        <ConnectedScreen {...props.match.params} />
    </WaitWhileBusy>
);
